import { useEffect, useState, useRef } from "react";
import { Select, IOptions } from "@/component/Select";
import Dialog from "@/component/Dialog";
import IC_MORE from "@/assets/record/ic_more.svg";
import FILEDELETE from "@/assets/record/ic_file_delete.svg?react";
import { SimpleRecord, collectRecord, cancelCollectRecord, deleteRecord, RenameRecord, deleteShareRecord, collectShareRecord, cancelCollectShareRecord } from "@/services/api_list";
import COLLECT from "@/assets/record/ic_collect.svg?react";
import { useNavigate } from "react-router-dom";
import IC_CLOSE_WIN from "@/assets/common/ic_close_win.svg?react";
import IC_CARD_PENDING from "@/assets/simulInter/ic_card_pending.svg";
import IC_CARD_RECORDING from "@/assets/simulInter/ic_card_recording.svg";
import { formatRecordTime } from "@/utils/formatter";
import { getRatio } from "@/utils/window";
import { RuningInLink } from "@/constants";
import { message } from "antd";
import { formatCreateDate } from "../util";
import './itemGrid.css';
import { recordTitleMaxLen } from "@/constants/record";
import fridayReporter from "@/utils/friday";
import { openShareModalV2 } from "@/sections/WebSummary/ShareModalV2";
import CardTitle, { CardTitleRef } from "../CardTitle";
import { ControllerStatus } from "@/types/simulInter";

interface IProp {
  isDeleted: boolean | null;
  model: SimpleRecord;
  handleCallback: (newModel: SimpleRecord) => void;
  deleteCallback: () => void;
  cancelCollectCallback: (newModel: SimpleRecord) => void;
}

export default function ItemGrid(prop: IProp) {
  const navigate = useNavigate();

  const { isDeleted, model, handleCallback, deleteCallback, cancelCollectCallback } = prop;

  const [options, setOptions] = useState<Array<IOptions>>([
    { id: "rename", label: "重命名" },
    { id: "collect", label: "收藏" },
    { id: "share", label: "分享" },
    { id: "delete", label: "删除" },
  ]);

  const [showMore, setShowMore] = useState(false);
  const [showSelect, setShowSelect] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [title, setTitle] = useState("");

  const [positioned, setPositioned] = useState<(number | undefined)[]>([0, 0, 0, 0]);

  const cardTitleRef = useRef<CardTitleRef>(null);

  useEffect(() => {
    setTitle(model.title);
    const newOptions = [...options];
    if (model.collect) {
      const collectIndex = newOptions.findIndex((item) => item.id === "collect");
      if (collectIndex !== -1) {
        newOptions[collectIndex] = { id: "cancelCollect", label: "取消收藏" };
      }
    }
    // 与我分享的，录制中和准备中的不允许重命名
    if (model.shareForMe || model.controllerStatus === ControllerStatus.PENDING || model.controllerStatus === ControllerStatus.RECORDING) {
      const renameIndex = newOptions.findIndex((item) => item.id === "rename");
      newOptions.splice(renameIndex, 1);
    }

    // 录制中和准备中的不允许分享
    if (model.controllerStatus === ControllerStatus.PENDING || model.controllerStatus === ControllerStatus.RECORDING) {
      const shareIndex = newOptions.findIndex((item) => item.id === "share");
      newOptions.splice(shareIndex, 1);
    }

    // 录制中的不允许删除
    if (model.controllerStatus === ControllerStatus.RECORDING) {
      const deleteIndex = newOptions.findIndex((item) => item.id === "delete");
      newOptions.splice(deleteIndex, 1);
    }

    setOptions(newOptions);
  }, []);

  const choseHandle = async (value: IOptions) => {
    switch (value.id) {
      case "rename": {
        cardTitleRef.current?.rename();
        break;
      }
      case "collect": {
        fridayReporter.pushData({
          eventCode: 'HomePage_ListManage_Favorite'
        })
        let res: boolean;
        if (model.shareForMe) {
          res = await collectShareRecord(model.streamName);
        } else {
          res = await collectRecord(model.streamName);
        }

        if (res) {
          const index = options.findIndex((item) => item.id === "collect");
          options[index] = { id: "cancelCollect", label: "取消收藏" };
          setOptions(options);
          model.collect = true;
          handleCallback(model);
          message.success("收藏成功");
        } else {
          message.error("收藏失败");
        }
        break;
      }
      case "cancelCollect": {
        let res: boolean;
        if (model.shareForMe) {
          res = await cancelCollectShareRecord(model.streamName);
        } else {
          res = await cancelCollectRecord(model.streamName);
        }
        if (res) {
          const index = options.findIndex((item) => item.id === "cancelCollect");
          options[index] = { id: "collect", label: "收藏" };
          setOptions(options);
          model.collect = false;
          cancelCollectCallback(model);
          message.success("已取消收藏");
        } else {
          message.error("取消收藏失败");
        }
        break;
      }
      case "share": {
        fridayReporter.pushData({
          eventCode: 'HomePage_ListManage_Share'
        })
        // if (model.shareForMe) {
        //   navigator?.clipboard?.writeText(`${model.shareUrl} 《${model.title}》}`);
        //   message.success("复制成功");
        // } else {
        openShareModalV2({
          streamName: model.streamName,
          title: model.title,
        });
        // }
        break;
      }
      case "delete": {
        setShowDialog(true);
        break;
      }
    }
    setShowMore(!showMore);
    setShowSelect(!showSelect);
  };

  const inputBlur = async (newTitle: string) => {
    if (!newTitle.trim()) {
      setTitle(model.title);
      return;
    }
    if (model.title === newTitle) return;
    setTitle(newTitle);
    const res = await RenameRecord(model.streamName, newTitle);
    if (res) {
      model.title = newTitle;
      handleCallback(model);
      fridayReporter.pushData({
        eventCode: 'HomePage_ListManage_Rename'
      })
    } else {
      setTitle(model.title);
    }
  };


  const cancleDlelete = () => {
    setShowDialog(false);
  };

  const confirmDlelete = async () => {
    fridayReporter.pushData({
      eventCode: 'HomePage_ListManage_Delete'
    })
    setShowDialog(false);
    let res: boolean;
    if (model.shareForMe) {
      res = await deleteShareRecord(model.streamName);
    } else {
      res = await deleteRecord(model.streamName);
    }
    if (res) {
      message.success("删除成功");
      deleteCallback();
    } else {
      message.error("删除失败");
    }
  };

  const itemHandle = () => {
    if (isDeleted) return;
    fridayReporter.pushData({
      eventCode: 'HomePage_EnterSummaryPage'
    })

    // 只有准备中和录制中状态才跳转到同传页面
    const isPendingOrRecording = model.controllerStatus === ControllerStatus.PENDING ||
      model.controllerStatus === ControllerStatus.RECORDING;

    if (isPendingOrRecording) {
      console.log("model.title", model.title);
      const params = new URLSearchParams({
        streamName: model.streamName,
        createdDate: model.createdDate,
        title: model.title,
        controllerStatus: model.controllerStatus.toString(),
        isFromList: "true"
      });
      // 如果有boardSn，则添加到参数中
      if (model.boardSn) {
        params.append('boardSn', model.boardSn);
      }
      navigate({
        pathname: "/simulInter",
        search: `?${params.toString()}`
      });
    } else {
      navigate({ pathname: "/summary", search: `?streamId=${model.streamName.replace("live/", "")}&isFromList=true` });
    }
  };

  const showMoreHandle = async () => {
    let devicePixelRatio = 1;
    if (RuningInLink) {
      devicePixelRatio = (await getRatio()) ?? 1;
    }
    setPositioned([undefined, undefined, 36 * devicePixelRatio, -13 * 4 * devicePixelRatio]);
    setShowSelect(true);
  };

  return (
    <div
      className="relative h-62.5 bg-white rd-2.5 py-5 flex flex-col justify-between relative hover:shadow-[1px_2px_12px_0px_#191D2633]"
      onMouseEnter={() => {
        if (isDeleted || model.controllerStatus === ControllerStatus.RECORDING) return;
        setShowMore(true);
      }}
      onMouseLeave={() => {
        if (isDeleted || model.controllerStatus === ControllerStatus.RECORDING) return;
        setShowSelect(false);
        setShowMore(false);
      }}
      onMouseDown={(e) => {
        e.stopPropagation();
      }}
      onClick={itemHandle}
    >
      {model.collect && <COLLECT className="w-5 h-5 absolute top-0 left-0"></COLLECT>}
      <Dialog isOpen={showDialog} title="确定删除" content="删除后，将无法恢复" onCancel={cancleDlelete} onConfirm={confirmDlelete}></Dialog>
      {isDeleted ? (
        <div className="flex flex-col mx-4 flex-1">
          <div className="flex justify-between">
            <span className="text-size-3.5 text-mx-secondary">抱歉，此内容无法查看</span>
            <IC_CLOSE_WIN
              className="w-5 h-5"
              onClick={(e) => {
                e.stopPropagation();
                confirmDlelete();
              }}
            ></IC_CLOSE_WIN>
          </div>
          <FILEDELETE className="w-12 h-17.58 self-center mt-12"></FILEDELETE>
          <span className="text-size-3.5 text-mx-quaternary mt-4.2 self-center">源文件已删除</span>
        </div>
      ) : (
        <div className="flex flex-col mx-4 flex-1">
          <div className="h-fit mb-3 min-h-12">
            <CardTitle ref={cardTitleRef} initialText={title} maxLength={recordTitleMaxLen} inputBlur={inputBlur} />
          </div>
          {/* 根据controllerStatus判断显示内容 */}
          {model.controllerStatus === ControllerStatus.PENDING ? (
            // 待录制状态：显示待录制占位图
            <div className="w-full h-27 mb-1 rd-1 flex items-center justify-center">
              <img src={IC_CARD_PENDING} className="w-full h-full object-contain" />
            </div>
          ) : model.controllerStatus === ControllerStatus.RECORDING ? (
            // 正在录制状态：显示正在录制占位图
            <div className="w-full h-27 mb-1 rd-1 flex items-center justify-center">
              <img src={IC_CARD_RECORDING} className="w-full h-full object-contain" />
            </div>
          ) : (
            // 完成状态：显示封面或总结
            model.coverUrl ? (
              <img src={model.coverUrl} className="w-full h-27 object-cover mb-1 rd-1 bg-#F4F6F9" />
            ) : (
              <div className="mx-1 text-size-3 text-mx-quaternary lh-5.5 mb-1 line-clamp-4 b-t-solid border-#F4F6F9 b-1px pt-4">
                <span>{model.summaryRecord.meetingSummary == null ? "等待内容生成" : model.summaryRecord.meetingSummary[0]}</span>
              </div>
            )
          )}
        </div>
      )}
      {!isDeleted && (
        <div className="flex overflow-hidden text-mx-quaternary text-size-3 justify-between mx-4 items-center whitespace-nowrap">
          <div className="flex flex-1 min-w-0">
            <div className="truncate">{model.origin}</div>
            <span className="ml-2">{formatCreateDate(model.createdDate)}</span>
          </div>
          {/* 根据controllerStatus显示不同状态 */}
          {model.controllerStatus === ControllerStatus.PENDING ? (
            <span className="ml-2">准备中</span>
          ) : model.controllerStatus === ControllerStatus.RECORDING ? (
            <span className="ml-2 text-mx-primary">录制中…</span>
          ) : (
            <span className="ml-2">{formatRecordTime(model.duration ?? 0)}</span>
          )}
        </div>
      )}

      {showMore && (
        <div className="absolute bottom-0 h-15 bg-white w-full rd-b-2 flex flex-justify-center pt-2">
          <div className={`relative rd-2 h-8 ${showSelect ? "bg-#F4F6F9" : ""}`}>
            <img
              className="w-8 h-8 hover:bg-#191D260D rd-1.5"
              src={IC_MORE}
              onClick={(e) => {
                e.stopPropagation();
                showMoreHandle();
              }}
            ></img>
            {showSelect && (
              <Select
                positioned={positioned}
                options={options}
                onChose={choseHandle}
                onOutsideCb={() => {
                  setShowSelect(!showSelect);
                }}
              ></Select>
            )}
          </div>
        </div>
      )}
      {/* 只有完成状态且未查看过才显示红点 */}
      {(model.controllerStatus === ControllerStatus.COMPLETED && !model.viewed) && (<div className="absolute top--.5 right--.5 w-3 h-3 bg-#FF887A rounded-full"></div>)}
    </div>
  );
}
